import Utils from "./utils";
import autoComplete from '@tarekraafat/autocomplete.js'

/* global KmClbScriptMain */

class Profile {
  constructor() {
    this.profilePage = document.querySelector('.js-clb-profile-page');

    if (!this.profilePage) {
      return;
    }

    this.formNotices = this.profilePage.querySelector('.js-clb-form-notices');
    this.editListingButtons = document.querySelectorAll('.js-clb-edit-listing');
    this.deleteListingButtons = document.querySelectorAll('.js-clb-delete-listing');
    this.autocompletes = document.querySelectorAll('.js-my-listings-autocomplete');
    this.repayButtons = document.querySelectorAll('.js-clb-repay-listing');

    this.global = KmClbScriptMain;
    this.user = this.global.user;

    this.data = {
      files: {
        keywords: `my-listings-u-${this.user.ID}.json`,
      },
      autocompleteInstance: null,
      threshold: this.user.type === 'auction' ? 1 : 2,
    }

    this.editListingHandler();
    this.deleteListingHandler();
    this.autocomplete();
    this.repayHandler();
  }

  editListingHandler() {
    if (!this.editListingButtons.length) {
      return;
    }

    this.editListingButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        const { editUrl } = e.currentTarget.dataset;

        window.location.href = editUrl;
      })
    });
  }

  deleteListingHandler() {
    if (!this.deleteListingButtons.length) {
      return;
    }

    this.deleteListingButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        if (this.isDeleting) {
          return;
        }

        const { deleteSlug, type } = e.currentTarget.dataset;
        const listing = e.currentTarget.closest('.js-clb-listing-item');

        if (confirm(`Are you sure you want to delete your ${type}?`)) {
          button.classList.add('is-loading');

          Utils.ajaxRequest(`km_clb_user_delete_${type}`, {
            slug: deleteSlug,
          }).then(response => {
            const message = response.success;

            this.formNotices.insertAdjacentHTML('afterbegin', message);

            this.formNotices.scrollIntoView({
              behavior:'smooth',
              block: 'center',
              inline: 'center',
            });

            setTimeout(() => {
              this.formNotices.innerHTML = '';
            }, 5000);

            listing.remove();
            this.isDeleting = false;
          });
        }

        this.isDeleting = true;
      })
    });
  }

  repayHandler() {
    if (!this.repayButtons.length) {
      return;
    }

    this.repayButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        if (this.isRepaying) {
          return;
        }

        const { href, slug, type } = e.currentTarget.dataset;

        if (href === 'new-payment') {
          console.log('new payment', this.global);
          button.classList.add('is-loading');

          Utils.ajaxRequest(`km_clb_user_repay_${type}`, {
            slug,
          }).then(response => {
            console.log('response', response);

            if (response?.redirect) {
              const timeout = response?.timeout || 3000;

              setTimeout(() => {
                window.location.href = response.redirect;
              }, timeout);
            } else if (response?.error) {
              button.insertAdjacentHTML('afterend', response.error);
            }

            this.isRepaying = false;
            button.classList.remove('is-loading');
          });
        } else {
          window.location.href = href;
        }
      })
    });
  }

  async autocompleteData(autocompleteKey) {
    const { filesUrl } = this.global.autocomplete;
    const fileName = this.data.files[autocompleteKey];

    const fileUrl = `${filesUrl}/${fileName}`;

    const response = await fetch(fileUrl);

    const data = await response.json();

    const list = data?.[autocompleteKey] || [];

    let listArray = Object.values(list);

    return listArray.sort();
  }

  autocomplete() {
    if (!this.autocompletes.length) {
      return;
    }

    this.autocompletes.forEach((autocomplete) => {
      const field = autocomplete;
      const { autocompleteKey } = field.dataset;

      this.data.autocompleteInstance = new autoComplete({
        selector: `#${field.getAttribute('id')}`,
        placeHolder: field.getAttribute('placeholder') || '',
        data: {
          src: async () => {
            return await this.autocompleteData(autocompleteKey);
          },
        },
        threshold: this.data.threshold,
        resultItem: {
            highlight: true,
        },
        resultsList: {
          maxResults: 20,
        }
      });

      field.addEventListener('selection', (e) => {
        e.target.value = e.detail.selection.value;
        this.data.autocompleteInstance.close();
      });
    });
  }
}

export default Profile;
